module.exports = __webpack_public_path__ + "media/images/athletes/2191-e8eea471b758cbd35fc6cbf21ac30adc.png";